/** The brief moment while we check for an existing session cookie. */
export function Checking() {
  return (
    <div className="flex min-h-dvh items-center justify-center" role="status" aria-label="Loading">
      <span className="border-ink/20 border-t-claret h-8 w-8 animate-spin rounded-full border-2" />
    </div>
  )
}
